import { permissions } from '@vanilla/services/PermissionService.js';

/**
 * Central navigation configuration.
 *
 * Leaf items: `{ route, label, icon, show? }`
 * Group items: `{ id, label, icon, defaultOpen?, children: [leaf] }`
 *
 * `show` is a permission predicate evaluated at render time. When a group has
 * children, it is rendered only if at least one child is visible.
 */
export const NAV_MAIN = [
    { route: 'leads', label: 'Leads', icon: 'deals', show: () => permissions.canView('leads') },
    { route: 'deals', label: 'Deals', icon: 'deals', show: () => permissions.canView('deals') },
    { route: 'calendar', label: 'Calendar', icon: 'calendar', show: () => permissions.canView('calendar') },
    { route: 'clients', label: 'Accounts', icon: 'accounts', show: () => permissions.canView('accounts') },
    { route: 'contacts', label: 'Contacts', icon: 'contacts', show: () => permissions.canView('contacts') },
    { route: 'dashboard', label: 'Dashboard', icon: 'dashboard', show: () => permissions.canView('dashboard') },
    { route: 'revenue', label: 'Revenue', icon: 'revenue', show: () => permissions.canView('revenue') },
    { route: 'goals', label: 'Goals', icon: 'goals', show: () => permissions.canView('goals') },
    { route: 'commissions', label: 'Commissions', icon: 'commissions', show: () => permissions.canView('commissions') },
    { route: 'reports', label: 'Reports', icon: 'reports', show: () => permissions.canView('reports') },
];

export const NAV_FOOTER = [
    {
        id: 'administration',
        label: 'Administration',
        icon: 'permissions',
        defaultOpen: true,
        children: [
            { route: 'users', label: 'Users', icon: 'users', show: () => permissions.canView('users') },
            { route: 'settings', label: 'Integrations', icon: 'integrations', show: () => permissions.canView('integrations') },
            { route: 'permissions', label: 'Permissions', icon: 'permissions', show: () => permissions.canView('permissions') },
            { route: 'data-management', label: 'Data management', icon: 'dataManagement', show: () => permissions.canAccessDataManagement() },
        ],
    },
];

export function getRouteTitle(route, sub = null) {
    if (route === 'commissions' && sub === 'rules') return 'Commission Rules';
    if (route === 'commissions' && sub === 'schedule') return 'Commission Schedule';
    for (const item of NAV_MAIN) {
        if (item.route === route) return item.label;
    }
    for (const group of NAV_FOOTER) {
        for (const child of group.children || []) {
            if (child.route === route) return child.label;
        }
    }
    if (!route) return 'Deals';
    return route.charAt(0).toUpperCase() + route.slice(1);
}

